import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './twoFactorScreen.module.css';

import { ReactComponent as ChevronDown } from 'asset/IconsPack/at_chevron-down-thin.svg';
import flagUs from 'asset/img/flag-us.svg';

import ScreenFrame from '../../components/ScreenFrame';
import Stepper from '../../components/Stepper';
import ThemedButton from '../../components/ThemedButton';
import ThemedInput from '../../components/ThemedInput';
import { TWO_FA_DESCRIPTION, TWO_FA_SUPPORT_LINK, TWO_FA_TITLE } from '../../helper/constants';

const countrySelector = (
    <>
        <img src={flagUs} alt="" className={styles.flag} />
        <ChevronDown className={styles.caret} />
    </>
);

const TwoFactorScreen = ({ logo, steps }) => (
    <ScreenFrame
        logo={logo}
        title={TWO_FA_TITLE}
        stepper={<Stepper steps={steps} activeStep={0} />}
        footer={<ThemedButton compact>Proceed</ThemedButton>}
    >
        <Typography className={styles.description}>{TWO_FA_DESCRIPTION}</Typography>
        <Box className={styles.form}>
            <ThemedInput label="Email *" placeholder="you@example.com" />
            <Box>
                <ThemedInput
                    label="Phone Number *"
                    placeholder="Enter phone number"
                    prefix={countrySelector}
                />
                <Typography className={styles.supportLink}>{TWO_FA_SUPPORT_LINK}</Typography>
            </Box>
        </Box>
    </ScreenFrame>
);

TwoFactorScreen.propTypes = {
    logo: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TwoFactorScreen;
